<div class="cart-preview text-light">
  <ng-container *ngIf="tickets$ | async as tickets">
    <ng-container *ngIf="tickets.length > 0">
      <span class="cart-preview-title"> {{ 'cart.tickets' | transloco }}: </span>
      <div class="cart-preview-items">
        <div *ngFor="let ticket of tickets">
          <div class="d-flex justify-content-between cart-preview-row">
            <div>
              <strong *ngIf="!displaySeatsOnly" class="pr-2">{{ ticket.product?.name }}</strong>
              <span class="d-inline-block pr-2" *ngIf="ticket.seat"
                >{{ 'global.row' | transloco }} {{ ticket.seat.rowLabel }} {{ 'global.seat' | transloco }}
                {{ ticket.seat.columnLabel }}
              </span>
            </div>
            <strong *ngIf="!displaySeatsOnly && ticket.product">{{
              ticket.product?.price | localeCurrency: ticket.product?.currency
            }}</strong>
          </div>
          <div
            class="d-flex justify-content-between text-light discount-line cart-preview-row"
            *ngIf="ticket.discountName"
          >
            <span class="text-small">{{ ticket.discountName }}</span>
            <span class="text-small">{{ ticket.discountedAmount | localeCurrency: 'EUR' }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="items$ | async as items">
    <ng-container *ngIf="items.length > 0">
      <span class="cart-preview-title">{{ 'cart.items' | transloco }}: </span>
      <div class="cart-preview-items">
        <div *ngFor="let item of items">
          <div class="d-flex justify-content-between cart-preview-row">
            <div>
              <strong class="pr-2">{{ item.quantity }}x</strong>
              <span>{{ item.title }}</span>
            </div>
            <strong>{{ item.total | localeCurrency: 'EUR' }}</strong>
          </div>
          <div
            class="d-flex justify-content-between text-light discount-line cart-preview-row"
            *ngIf="item.discountName"
          >
            <span class="text-small">{{ item.discountName }}</span>
            <span class="text-small">{{ item.discountedAmount | localeCurrency: 'EUR' }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-container *ngIf="giftCards$ | async as giftCards">
  <div class="cart-preview giftcard" *ngIf="giftCards.length > 0">
    <span class="cart-preview-title">{{ 'cart.giftcard' | transloco }}: </span>
    <div class="cart-preview-items">
      <div class="d-flex justify-content-between align-items-center cart-preview-row" *ngFor="let card of giftCards">
        <div class="d-flex align-items-center gap-2">
          <strong> {{ card.name }} </strong>
          <button
            *ngIf="card.can_delete !== false"
            class="btn-icon-remove"
            type="button"
            (click)="removeGiftCard(card.id)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="d-flex align-items-center gap-2 cart-preview-amount">
          <strong>-{{ Math.min(card.amount, total$ | async) | localeCurrency: 'EUR' }}</strong>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="boscoopcards$ | async as boscoopcards">
  <div class="cart-preview giftcard" *ngIf="boscoopcards.length > 0">
    <span class="cart-preview-title">{{ 'bioscoopbon.bon' | transloco }}: </span>
    <div class="cart-preview-items">
      <div class="d-flex justify-content-between align-items-center cart-preview-row" *ngFor="let card of boscoopcards">
        <div class="d-flex align-items-center gap-2">
          <strong>**** {{ card.code | slice: -4 }}</strong>
          <button
            *ngIf="card.can_delete !== false"
            class="btn-icon-remove"
            type="button"
            (click)="removeBioscoopcard(card.id)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="d-flex align-items-center gap-2 cart-preview-amount">
          <strong>-{{ card.applied_amount | localeCurrency: 'EUR' }}</strong>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="deferredPayments$ | async as deferredPayments">
  <div class="cart-preview giftcard" *ngIf="deferredPayments.length > 0">
    <span class="cart-preview-title">{{ 'cart.applied_payments' | transloco }}: </span>
    <div class="cart-preview-items">
      <div
        class="d-flex justify-content-between align-items-center cart-preview-row"
        *ngFor="let payment of deferredPayments"
      >
        <strong>{{ payment.payment_method_name }}</strong>
        <strong>-{{ payment.amount | localeCurrency: 'EUR' }}</strong>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="discounts$ | async as discounts">
  <div class="cart-preview giftcard" *ngIf="discounts.length > 0">
    <span class="cart-preview-title">{{ 'cart.discount' | transloco }}: </span>
    <div class="cart-preview-items">
      <div
        class="d-flex justify-content-between align-items-center cart-preview-row"
        *ngFor="let discount of discounts"
        [class.inactive]="discount.amount >= 0"
      >
        <div class="d-flex align-items-center gap-2">
          <strong>{{ discount.name || discount.code }}</strong>
          <button class="btn-icon-remove" type="button" (click)="removeDiscount(discount.discount_code_id)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="d-flex align-items-center gap-2 cart-preview-amount">
          <strong>{{ discount.amount | localeCurrency: 'EUR' }}</strong>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="paymentMethod$ | async as paymentMethod">
  <div class="cart-preview giftcard" *ngIf="paymentMethod.methodCost && paymentMethod.methodCost > 0">
    <span class="cart-preview-title">{{ 'cart.payment' | transloco }}: </span>
    <div class="cart-preview-items">
      <div class="d-flex justify-content-between">
        <strong> </strong>

        <strong>{{ paymentMethod.methodCost | localeCurrency: 'EUR' }}</strong>
      </div>
    </div>
  </div>
</ng-container>

<div class="cart-preview-summary d-flex justify-content-end" *ngIf="!hideSummary && (seatsAssigned$ | async)">
  <strong class="text-bold text-md" *ngIf="!displaySeatsOnly"
    >{{ 'global.total' | transloco }}: {{ pendingAmount$ | async | localeCurrency: 'EUR' }}</strong
  >
</div>
<ng-container *ngFor="let reservation of reservations$ | async">
  <div class="cart-preview" *ngIf="isReservationSetByUser(reservation)">
    <span class="cart-preview-title">{{ 'cart.reservation' | transloco }}: </span>
    <div class="cart-preview-items">
      <span class="text-light">{{
        isBeforeShow(reservation) ? ('cart.before_movie' | transloco) : ('cart.after_movie' | transloco)
      }}</span>
      <strong> {{ reservation.table_start | date: 'HH:mm' }} </strong>
      <span class="text-light"
        >{{ reservation.seats }}
        {{ (reservation.seats > 1 ? 'cart.people_other' : 'cart.people_one') | transloco }}</span
      >
    </div>
  </div>
</ng-container>
